import React from "react";
export function EmissionClassDisplay(props) {
    if (props.value == null)
        return React.createElement(React.Fragment, null);
    return React.createElement("span", null, props.value);
}
